import { IGame } from "./../../entities";
import { provider } from "../../providers";

export interface GetGameByIdPayload {
  id: number;
}

export const GetGameById = async (params: GetGameByIdPayload): Promise<IGame> =>
  provider.Request("/games/{id}", params);
